export const OTP_MISMATCH_STATUS = 'UNIQUE CODE DOES NOT MATCH THE OFFER SELECTED';
export const ALREADY_HAS_ACCOUNT_STATUS = 'USER ALREADY HAS AN ACCOUNT';

export const getCorrectionStatus = (app) => app?.payload?.correction_required?.status ?? null;

export const isOtpMismatchStatus = (status) =>
  typeof status === 'string' && status.trim().toUpperCase() === OTP_MISMATCH_STATUS;

export const hasOtpMismatch = (app) => isOtpMismatchStatus(getCorrectionStatus(app));

export const isAlreadyHasAccountStatus = (status) =>
  typeof status === 'string' && status.trim().toUpperCase() === ALREADY_HAS_ACCOUNT_STATUS;

export const hasAlreadyHasAccount = (app) => isAlreadyHasAccountStatus(getCorrectionStatus(app));

export const EXISTING_CUSTOMER_MARKER = '{EXISTING_CUSTOMER}';
export const EXISTING_CUSTOMER_STATUS = 'EXISTING_CUSTOMER';

export const isExistingCustomerStatus = (status) =>
  typeof status === 'string' && status.trim().toUpperCase() === EXISTING_CUSTOMER_STATUS;

export const hasExistingCustomer = (app) =>
  isExistingCustomerStatus(getCorrectionStatus(app)) ||
  Boolean(app?.payload?.correction_required?.message?.includes(EXISTING_CUSTOMER_MARKER));
